import { ActionMessageStringHandler } from "@app/shared/resources/action-message-string-handler";
import { ActionWord } from "@app/shared/resources/action-word";
import { DataServiceError } from "./data-service-error";

/**
 * Handle a response from one of our external API calls.
 */
export class HttpResponseHandler {
    message = "There was an error";

    /**
     * A handler for responses from external API calls.
     *
     * @param entityType The type of entity we being used
     * @param actionType The type of action being performed on the entity
     * @param response A custom string response or a DataServiceError
     * @param isError Whether to use error styling when displaying the response
     * @description This class, typically used with the Material SnackBar, is used to create a response message
     * to be displayed to the user. Used by the generic HandleSuccessMessage and HandleSuccessMessage
     * handlers which display the message, it takes an entity type (user, device, company, etc.),
     * an action word and/or a response. If no specific string response is given,
     * the class sets a generic message in the form of:
     *
     * if (not an error) {
     *   "The [entityType] was successfully [actionType]"
     * } else {
     *   "The [entityType] was not [actionType]"
     * }
     *
     * If a specific message is provided as response, then it is set as the message.
     * If an error occurred and we have an error code in the response, ActionMessageStringHandler
     * may set message to a specific response string
     */
    constructor(entityType?: string, actionType?: ActionWord, response?: string | DataServiceError<any>, public isError = false) {
        if (isError && response) {
            this.message =
                ActionMessageStringHandler.getSpecificErrorMessageString(
                    entityType,
                    typeof response !== "string" ? response.error : response
                ) || ActionMessageStringHandler.getGenericMessageString(entityType, actionType, this.isError);
        } else if (typeof response === "string") {
            this.message = response;
        } else {
            this.message = ActionMessageStringHandler.getGenericMessageString(entityType, actionType, this.isError);
        }
    }
}
